import React from 'react'

import { Input } from 'ui/components/Input'

import { useSectionTextAttributeEditorState } from './hooks/useSectionTextAttributeEditorState'
import { SectionAttributeEditorProps } from './types'

type SectionTextAttributeEditorProps = SectionAttributeEditorProps<string>

export const SectionTextAttributeEditor: React.FC<SectionTextAttributeEditorProps> = ({
    label,
    value,
    onChange,
    isReadOnly,
    placeholder,
}) => {
    const { localValue, handleChange } = useSectionTextAttributeEditorState({
        value,
        onChange,
    })

    return (
        <Input
            type="text"
            size="m"
            label={label}
            value={localValue}
            onChange={handleChange}
            readOnly={isReadOnly}
            placeholder={placeholder}
        />
    )
}
